import FormValidations from "../FormValidations";
import {SimpleInputValidator} from "./SimpleInputValidator";

export class PhoneInputValidator implements SimpleInputValidator {
    isValid(value: string, required: boolean): boolean {
        return required
            ? FormValidations.isValidMandatoryPhone(value)
            : FormValidations.isValidPhone(value);
    }
}